<p>location-product-pricing-add-or-update works!</p>
